import "./BonusOfferCard.css";

const BonusOfferCard = ({
  icon,
  title,
  price,
  description,
  badge,
}) => {
  return (
    <div className="bonus-card">

      <div className="bonus-icon">
        {icon}
      </div>

      <h3 className="bonus-title">
        <span>Free</span> {title}
      </h3>

      <h4 className="bonus-price">
        {price}
      </h4>

      <p className="bonus-description">
        {description}
      </p>

      <div className="bonus-badge">
        • {badge}
      </div>


    </div>
  );
};

export default BonusOfferCard;